import './GGModalWindow.scss'
import {  Modal, Typography } from '@mui/material';
import { useEffect } from 'react';
import ModalCloseBtn from '../../CommonComponents/ModalButtons/ModalCloseBtn/ModalCloseBtn';

interface GGModalWindowPropsInterface {
    childView: JSX.Element;
    open: boolean;
    onCloseHandler: () => void;
    title: string;
    backgroundColor?: string;
    width?: string;
    disableCloseButton?: boolean;
}

const GGModalWindow = ({childView, open, onCloseHandler, title, width, backgroundColor, disableCloseButton}: GGModalWindowPropsInterface) => {


    const onClose = (_event: any, reason: any) => {
        if(reason && reason === 'backdropClick') {
            return
        }
        onCloseHandler()
    }

    const disableScroll = () => {
        document.body.style.overflow = "hidden";
    };

    const enableScroll = () => {
        document.body.style.overflow = "";
    };
      
    const modalStyle = width ? {
        width: `${width}`,
    } : {}

    const modalConetentContainerStyle = {
        backgroundColor: backgroundColor ? backgroundColor : 'white'
    }
    
    useEffect(() => {
        if(open) disableScroll()
        else enableScroll()
        
        return () => enableScroll();
    // eslint-disable-next-line
    }, [open])

  return (
    <Modal         
        open={open}
        onClose={onClose}
        disableEscapeKeyDown
        className='modal-overlay'
        disableRestoreFocus
       >
            <div className="modal-container" style={modalStyle}>
                <div className="modal-header">
                    <div className='modal-header-content'>
                        <Typography className='modal-title'>{title}</Typography>
                        <ModalCloseBtn disabled={disableCloseButton} handleCancel={onCloseHandler} />
                    </div>
                    <hr  className='divider-line'></hr>
                </div>

            <div className="modal-content" style={modalConetentContainerStyle}>{childView}</div>
        </div>
    </Modal>
  )
}

export default GGModalWindow;